import React from 'react';
import { Sparkles, BookOpen } from 'lucide-react';

export type TabType = 'ai-assistant' | 'library';

interface TabSelectorProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  showIcons?: boolean;
}

const TabSelector: React.FC<TabSelectorProps> = ({ activeTab, onTabChange, showIcons = true }) => {
  return (
    <div className="flex border-b border-gray-200 dark:border-gray-700">
      <button
        className={`flex-1 flex items-center justify-center py-3 px-4 text-sm font-medium transition-all duration-200 ${
          activeTab === 'ai-assistant'
            ? 'text-white relative overflow-hidden'
            : 'text-purple-600 dark:text-purple-400 hover:bg-gray-50 dark:hover:bg-gray-700'
        }`}
        onClick={() => onTabChange('ai-assistant')}
        style={{
          background: activeTab === 'ai-assistant' 
            ? 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' 
            : ''
        }}
      >
        <span className="relative z-10 flex items-center">
          {showIcons && <Sparkles size={16} className="mr-2" />}
          AI Assistant
        </span>
        {activeTab === 'ai-assistant' && (
          <span className="absolute inset-0 bg-white opacity-10"></span>
        )}
      </button>
      
      <button
        className={`flex-1 flex items-center justify-center py-3 px-4 text-sm font-medium transition-all duration-200 ${
          activeTab === 'library'
            ? 'bg-blue-50 dark:bg-gray-700 text-blue-600 dark:text-gray-100'
            : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
        }`}
        onClick={() => onTabChange('library')}
      >
        {showIcons && <BookOpen size={16} className="mr-2" />}
        Library
      </button>
    </div>
  );
};

export default TabSelector;
